import type { CSSProperties } from 'react';
import './skeleton.css';

type SkeletonProps = {
  className?: string;
  style?: CSSProperties;
  /** text | title | avatar | card | row | bare */
  variant?: 'text' | 'title' | 'avatar' | 'card' | 'row' | 'bare';
  width?: string | number;
  height?: string | number;
};

export function Skeleton({
  className = '',
  style,
  variant = 'bare',
  width,
  height,
}: SkeletonProps) {
  const variantClass = variant === 'bare' ? '' : `sk--${variant}`;
  return (
    <span
      className={`sk ${variantClass} ${className}`.trim()}
      style={{ width, height, ...style }}
      aria-hidden
    />
  );
}
